import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIonqLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "IonQ" }),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_5263_1268)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M39.923 9.68299L67.9846 24.8991L76.8461 20.0576L39.923 0L3 20.0576L11.8615 24.8991L39.923 9.68299Z",
					fill: "#D4D4D5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.8613 24.8988V55.1005L14.8152 53.4866L20.969 50.259V29.7402L39.9228 19.3656V12.6797V9.68262L11.8613 24.8988Z",
					fill: "#ED7C37"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M67.9841 24.8991V55.1008L65.0303 53.487L76.8456 59.9423V20.0576L67.9841 24.8991Z",
					fill: "#B7B7B8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M67.9844 24.8988L39.9229 9.68262V12.6797V19.3656L58.8767 29.7402V50.259L65.0305 53.4866L67.9844 55.1005V24.8988Z",
					fill: "#DE5126"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M58.877 59.9424V69.6254L67.9846 74.4669V64.7839L58.877 59.9424Z",
					fill: "#929293"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.8154 53.487L11.8615 55.1008V24.8991L3 20.0576V59.9423L39.923 79.9999V70.317L11.8615 55.1008L14.8154 53.487Z",
					fill: "#929293"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39.9229 80L58.8767 69.6254V59.9424L39.9229 70.317V80Z",
					fill: "#B7B7B8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M67.9843 55.1013L65.2767 53.718L58.8767 50.2598L39.9228 60.6344L20.969 50.2598L14.8152 53.4874L11.8613 55.1013L39.9228 70.3174L58.8767 59.9428L67.9843 64.7843L76.8459 59.9428L67.9843 55.1013Z",
					fill: "#F89B33"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M76.8459 59.9424L67.9844 64.7839V74.4669L76.8459 69.6254V59.9424Z",
					fill: "#B7B7B8"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_5263_1268",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 80,
				height: 80,
				fill: "white"
			})
		}) })
	]
});
export default SvgIonqLogo;
